import { atom } from "recoil";
import { IPackageForm } from "types/package.d";

export const carPackageState = atom({
  key: "carPackageState",
  default: null as IPackageForm | null,
});
